<template>
  <slot v-if="isClient"></slot>
</template>

<script>
export default {
  name: 'OnlyOnClient',
  data() {
    return {
      isClient: false,
    };
  },
  mounted() {
    if(typeof window !== undefined){
      this.isClient = true;
    }
  },
};
</script>
